import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
  class: "upload_push_body"
};
const _hoisted_2 = {
  class: "upload_push_body_nr"
};
const _hoisted_3 = {
  class: "bt_top"
};
const _hoisted_4 = {
  class: "clock_task"
};
const _hoisted_5 = {
  style: {
    "width": "100%"
  }
};
const _hoisted_6 = {
  key: 0,
  style: {
    "width": "100%",
    "margin-top": "20px",
    "font-size": "15px"
  }
};
const _hoisted_7 = {
  style: {
    "width": "100%",
    "margin-top": "20px",
    "border-radius": "15px",
    "overflow": "hidden"
  }
};
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = {
  key: 0,
  class: "clock_task"
};
const _hoisted_11 = {
  class: "clock_task_top"
};
const _hoisted_12 = {
  style: {
    "display": "flex"
  }
};
const _hoisted_13 = {
  class: "clock_task_nr"
};
const _hoisted_14 = {
  key: 0,
  class: "clock_task_nr_text"
};
const _hoisted_15 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_16 = {
  key: 1,
  class: "push_btn"
};
const _hoisted_17 = {
  class: "pic-box"
};
const _hoisted_18 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/img/member_clock/push_img.png",
  alt: ""
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "vido-box"
};
const _hoisted_21 = {
  key: 0,
  src: "https://www.mimodental.com/assets/imgData/img/member_clock/push_vido.png",
  alt: ""
};
const _hoisted_22 = ["src"];
const _hoisted_23 = {
  key: 2,
  style: {
    "font-size": "20px"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_input = _resolveComponent("el-input");
  const _component_van_uploader = _resolveComponent("van-uploader");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("h1", null, _toDisplayString($setup.hd_data.title), 1), _createElementVNode("div", {
    onClick: _cache[0] || (_cache[0] = (...args) => $setup.history && $setup.history(...args))
  }, "查看历史记录")]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", null, "观看训练" + _toDisplayString($setup.hd_data.type == 'video/mp4' ? '视频' : '图片'), 1)]), $setup.hd_data.type == 'video/mp4' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("span", null, _toDisplayString($setup.hd_data.videoExplain), 1)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, [$setup.hd_data.type == 'video/mp4' ? (_openBlock(), _createElementBlock("video", {
    key: 0,
    style: {
      "width": "100%",
      "height": "100%"
    },
    controls: "",
    muted: "",
    loop: "",
    src: $setup.hd_data.url
  }, null, 8, _hoisted_8)) : (_openBlock(), _createElementBlock("img", {
    key: 1,
    src: $setup.hd_data.url,
    style: {
      "width": "100%"
    },
    alt: ""
  }, null, 8, _hoisted_9))])]), $setup.hd_data.statusStr != '已完成' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("span", null, _toDisplayString($setup.hd_data.uploadFlow != 0 ? '请上传训练成果' : '说明'), 1)]), $setup.hd_data.uploadFlow != 0 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "clock_task_top_btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.tj && $setup.tj(...args))
  }, " 提交 ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_13, [$setup.hd_data.uploadFlow != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_cache[5] || (_cache[5] = _createElementVNode("img", {
    src: "https://www.mimodental.com/assets/imgData/img/member_clock/bz.png",
    alt: ""
  }, null, -1)), _createElementVNode("div", _hoisted_15, [_createVNode(_component_el_input, {
    modelValue: $setup.push_data.textarea,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.push_data.textarea = $event),
    rows: 5,
    type: "textarea",
    placeholder: "备注"
  }, null, 8, ["modelValue"])])])) : _createCommentVNode("", true), $setup.hd_data.uploadFlow != 0 ? (_openBlock(), _createElementBlock("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createVNode(_component_van_uploader, {
    "after-read": $setup.afterReadImg,
    accept: "image/*"
  }, {
    default: _withCtx(() => [!$setup.push_data.img ? (_openBlock(), _createElementBlock("img", _hoisted_18)) : (_openBlock(), _createElementBlock("img", {
      key: 1,
      src: $setup.push_data.img,
      style: {
        "width": "197px",
        "height": "197px",
        "margin-right": "20px"
      },
      alt: ""
    }, null, 8, _hoisted_19))]),
    _: 1
  }, 8, ["after-read"]), $setup.push_data.img ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[3] || (_cache[3] = $event => $setup.push_data.img = ''),
    class: "close-btn"
  }, "X")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_20, [_createVNode(_component_van_uploader, {
    "before-read": $setup.beforeReadVido,
    "after-read": $setup.afterReadVido,
    accept: "video/*"
  }, {
    default: _withCtx(() => [!$setup.push_data.vido ? (_openBlock(), _createElementBlock("img", _hoisted_21)) : (_openBlock(), _createElementBlock("video", {
      key: 1,
      src: $setup.push_data.vido,
      style: {
        "width": "197px",
        "height": "197px"
      },
      autoplay: "",
      muted: "",
      loop: ""
    }, null, 8, _hoisted_22))]),
    _: 1
  }, 8, ["before-read", "after-read"]), $setup.push_data.vido ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    onClick: _cache[4] || (_cache[4] = $event => $setup.push_data.vido = ''),
    class: "close-btn"
  }, "X")) : _createCommentVNode("", true)])])) : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString($setup.hd_data.videoExplain), 1))])])) : _createCommentVNode("", true)])]);
}